import { DeleteResponse, TextBlockListResponse, TextBlockResponse } from '../dto/ResDtoRepository';
import { CreateTextBlockReq, DeleteTextBlockReq, UpdateTextBlockReq, UpdateReorderListReq } from '../dto/ReqDtoRepository';
import { sendApiRequest, sendDeleteApiRequest } from './apiConfig';


/** 소유자: PE Import TextBlock 목록. public GET이 아님. aui 필수. */
export const getTextBlockListForOwner = async (aui: string, textId: string): Promise<TextBlockListResponse> => {
  return sendApiRequest<TextBlockListResponse>(
    'get',
    `/api/v1/text-block/list/owner?aui=${aui}&textId=${textId}`,
  );
};

export const createTextBlock = async (aui: string, data: CreateTextBlockReq): Promise<TextBlockResponse> => {
  return sendApiRequest<TextBlockResponse>('post', `/api/v1/text-block?aui=${aui}`, data);
};

export const updateTextBlock = async (aui: string, data: UpdateTextBlockReq): Promise<TextBlockResponse> => {
  return sendApiRequest<TextBlockResponse>('put', `/api/v1/text-block?aui=${aui}`, data);
};

export const deleteTextBlock = async (aui: string, data: DeleteTextBlockReq): Promise<DeleteResponse> => {
  return sendDeleteApiRequest<DeleteResponse>(`/api/v1/text-block?aui=${aui}&textBlockId=${data.textBlockId}`);
};

export const reorderTextBlock = async (aui: string, data: UpdateReorderListReq): Promise<TextBlockListResponse> => {
  return sendApiRequest<TextBlockListResponse>('put', `/api/v1/text-block/reorder?aui=${aui}`, data);
};